var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-08-30
 * @brief EHP ManageMent - CheckManageMent 개발
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
//
import { useAsync } from "react-async";
// recoil && state
import { useRecoilValue, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
//utils
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
import EhpPagination from "../../common/pagination/EhpPagination";
import { useNavigate } from "react-router-dom";
//
/**
 * @brief EHP ManageMent - ApprovalManageMent 개발 컴포넌트, 반응형 동작
 * @param param0 width:<number>: 화면(브라우저) 가로 사이즈
 * @param param1 height:<number>: 화면(브라우저) 세로 사이즈
 * @returns react components
 */
function CheckItemApproval(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //화면 이동
    const navigate = useNavigate();
    //props
    const setParentPopWin = props.setPopWin;
    //
    const [toggle, setToggle] = useState(false);
    const [checkDto, setCheckDto] = useState([]);
    const [engineerList, setEngineerList] = useState([]);
    const [errorList, setErrorList] = useState([]);
    //
    const defaultPageInfo = { "size": 10, "totalElements": 0, "totalPages": 0, "number": 0 };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    let appPath = 'page=' + pageInfo.number + '&size=' + pageInfo.size;
    // 진단점검 요청  List
    const { data: data, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/company/zone/subzone/room/panel/item/approvallist?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath
    });
    // 진단점검 요청 List
    useEffect(() => {
        // error page 이동
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, data);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setCheckDto(data.body);
                setPageInfo(data.data.page);
            }
            else {
                setErrorList(data.body.errorList);
            }
        }
    }, [data]);
    // Engineer List
    const { data: retData } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/users/role/engineer`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
    });
    useEffect(() => {
        if (retData) {
            if (retData.codeNum == CONST.API_200) {
                // clog("IN ENGINEERLIST : RES : " + JSON.stringify(retData.body))
                setEngineerList(retData.body);
            }
            else {
                setErrorList([...errorList, retData.body.errorList]);
            }
        }
    });
    // 요청 완료 팝업
    function checkPop(e, list) {
        // clog("IN CHECKPOP : FUNC : " + JSON.stringify(list));
        setParentPopWin("pop-casecheck-ok", React.createElement(CheckApprovalPop, { htmlHeader: React.createElement("h1", null, "\uC9C4\uB2E8\uC810\uAC80/\uB178\uD6C4\uAD50\uCCB4 \uC694\uCCAD"), itemInfo: list, engineerList: engineerList }));
        CUTIL.jsopen_Popup(e);
    }
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    function toggles(e) {
        if (toggle === false) {
            setToggle(true);
        }
        else {
            setToggle(false);
        }
    }
    const checkList = (checkDto === null) ? null : checkDto;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "page-top more__detail", onClick: (e) => toggles(e) },
            React.createElement("h2", null, "\uC9C4\uB2E8\uC810\uAC80/\uB178\uD6C4\uAD50\uCCB4 \uC2B9\uC778 \uC694\uCCAD"),
            React.createElement("p", { className: "user-num" }, pageInfo.totalElements)),
        React.createElement("div", { className: `area__right_content detail__view  ${(toggle) ? "on" : ""}` },
            React.createElement("div", { className: "tbl-list hcal-vh-315" },
                React.createElement("table", { summary: "\uAE30\uAE30 \uBA85, \uBAA8\uB378 \uBA85, \uB2F4\uB2F9\uC790, \uC2B9\uC778\uC694\uCCAD \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC9C4\uB2E8\uC810\uAC80 \uC2B9\uC778 \uC694\uCCAD \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." },
                    React.createElement("caption", null, "\uC9C4\uB2E8\uC810\uAC80 \uC2B9\uC778 \uC694\uCCAD \uB9AC\uC2A4\uD2B8"),
                    React.createElement("colgroup", null,
                        React.createElement("col", { style: { "width": "" } })),
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "col" }),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uAE30\uAE30 \uBA85"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uBAA8\uB378 \uBA85"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uB2F4\uB2F9\uC790"),
                            React.createElement("th", { scope: "col" }, "\uC2B9\uC778\uC694\uCCAD"))),
                    React.createElement("tbody", null, checkList.map((list, idx) => (React.createElement("tr", { key: "CHECK_" + idx },
                        React.createElement("td", { className: "txt-left" },
                            React.createElement("img", { src: (list.itemStep == "BASIC_DONE" && list.oldDeviceConsult == 0) ?
                                    require("/static/img/icon_p.png")
                                    :
                                        require("/static/img/icon_c.png"), style: { "width": "24px", "height": "24px" }, alt: (list.itemStep == "BASIC_DONE" && list.oldDeviceConsult == 0) ?
                                    "Premium" : "change" })),
                        React.createElement("td", { className: "txt-left" }, list.spg.name),
                        React.createElement("td", { className: "txt-left" },
                            React.createElement("p", { className: "ellipsis" }, list.itemName)),
                        React.createElement("td", { className: "txt-left" }, list.responsible),
                        React.createElement("td", null, (list.itemStatus == "REQUESTED") ?
                            React.createElement("button", { type: "button", className: "bg-blue center js-open", "data-pop": "pop-casecheck-ok", onClick: (e) => checkPop(e, list) },
                                React.createElement("span", { "data-pop": "pop-casecheck-ok" }, "\uC694\uCCAD \uC644\uB8CC"))
                            : (list.oldDeviceConsult == 1) ?
                                React.createElement("button", { type: "button", className: "bg-pink center js-open", "data-pop": "pop-casecheck-ok", onClick: (e) => checkPop(e, list) },
                                    React.createElement("span", { "data-pop": "pop-casecheck-ok" }, "\uAD50\uCCB4\uC694\uCCAD"))
                                :
                                    React.createElement("button", { type: "button", className: "bg-navy center" },
                                        React.createElement("span", null, "\uC811\uC218 \uC644\uB8CC"))))))))),
            (pageInfo) && React.createElement(EhpPagination, { componentName: "CheckApproval", pageInfo: pageInfo, handleFunc: handleCurPage }))));
}
;
export default CheckItemApproval;
//진단점검 요청 팝업
function CheckApprovalPop(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //
    const itemInfo = props.itemInfo;
    const engineerList = props.engineerList;
    //
    const [itemDetailInfo, setItemDetailInfo] = useState(null);
    const [checkChange, setCheckChange] = useState(null);
    const [errorList, setErrorList] = useState([]);
    const [dispName, setDispName] = useState("");
    const [engName, setEngName] = useState("");
    const [engNull, setEngNull] = useState(false);
    // checkItem detail info
    const { data: retData } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/company/zone/subzone/room/panel/item/detail`,
        appQuery: { "itemId": itemInfo.itemId },
        userToken: userInfo.loginInfo.token,
        watch: itemInfo.itemId
    });
    useEffect(() => {
        if (retData) {
            if (retData.codeNum == CONST.API_200) {
                // clog("IN CHECKPOP : RES : " + JSON.stringify(retData.body))
                setItemDetailInfo(retData.body);
            }
            else {
                setErrorList(retData.body.errorList);
            }
        }
    });
    // PDF 다운로드
    function onClickReportDownload(e, ckeckItem) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "GET",
                "appPath": `/api/v2/report/${ckeckItem.reportId}`,
                "appQuery": {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    // clog("IN COMUTILS : GET FILEDOWNLOAD : " + JSON.stringify(data));
                    HTTPUTIL.fileDownload(`${ckeckItem.itemName}_진단점검리포트.PDF`, data.body.fileLink);
                }
                else {
                }
            }
        });
    }
    // engineer 배정 on/off
    function engineerSelect(e, eng) {
        if (checkChange != eng.userIdPk) {
            setCheckChange(eng.userIdPk);
        }
        else if (checkChange == eng.userIdPk) {
            setCheckChange(0);
        }
    }
    // 배정 완료 시 API
    function engineerDone(itemId, userIdPk, requestUserIdPk) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "POST",
                "appPath": `/api/v2/product/company/zone/subzone/room/panel/item/engineer`,
                "appQuery": {
                    "userIdPk": userIdPk,
                    "requestUserIdPk": requestUserIdPk,
                    "itemId": itemId
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    alert("담당자 배정 접수가 되었습니다.");
                    window.location.reload();
                }
                else {
                    alert(data.data.errorList[0].msg);
                }
            }
        });
    }
    // 노후교체 완료 시 API
    function changeDone(itemId, userIdPk, requestUserIdPk) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "PUT",
                "appPath": `/api/v2/product/company/zone/subzone/room/panel/item/deviceconsult`,
                "appQuery": {
                    "userIdPk": userIdPk,
                    "requestUserIdPk": requestUserIdPk,
                    "itemId": itemId
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    alert("담당자 배정 접수가 되었습니다.");
                    window.location.reload();
                }
                else {
                    alert(data.data.errorList[0].msg);
                }
            }
        });
    }
    //엔터키
    function handleEnterKey(e) {
        if (e.key === 'Enter') {
            setEngName(dispName);
        }
    }
    return (React.createElement(React.Fragment, null,
        (itemDetailInfo) && React.createElement("div", { className: "popup__body layout-vertical" },
            React.createElement("h2", null,
                React.createElement("img", { src: (itemInfo.itemStep == "BASIC_DONE" && itemInfo.oldDeviceConsult == 0) ?
                        require("/static/img/icon_p.png")
                        :
                            require("/static/img/icon_c.png"), 
                    // style={{ "width": "24px", "height": "24px" }}
                    alt: (itemInfo.itemStep == "BASIC_DONE" && itemInfo.oldDeviceConsult == 0) ?
                        "Premium" : "change" }),
                React.createElement("span", null,
                    itemDetailInfo.companyName + " " + itemDetailInfo.zoneName,
                    " \uC0AC\uC5C5\uC7A5")),
            React.createElement("div", { className: "inline mb-16" },
                React.createElement("p", { className: "tit" }, "\uC0AC\uC5C5\uC7A5 \uC8FC\uC18C"),
                React.createElement("p", null, itemDetailInfo.zoneAddress)),
            React.createElement("div", { className: "tbl-list type2" },
                React.createElement("table", { summary: "\uC0C1\uC138\uC0AC\uC5C5\uC7A5,\uC804\uAE30\uC2E4,\uAE30\uAE30 \uBA85,\uBAA8\uB378 \uBA85,\uC2DC\uB9AC\uC5BC \uBC88\uD638,\uB2F4\uB2F9\uC790,\uC810\uAC80 \uC77C\uC790,\uD3C9\uAC00\uC810\uC218,Report,Memo \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC0AC\uC5C5\uC7A5 \uC815\uBCF4 \uBAA9\uB85D \uC785\uB2C8\uB2E4." },
                    React.createElement("caption", null, "\uC0AC\uC5C5\uC7A5 \uC815\uBCF4 \uBAA9\uB85D"),
                    React.createElement("colgroup", null,
                        React.createElement("col", { style: {} })),
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC0C1\uC138\uC0AC\uC5C5\uC7A5"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC804\uAE30\uC2E4"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uAE30\uAE30 \uBA85"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uBAA8\uB378 \uBA85"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC2DC\uB9AC\uC5BC \uBC88\uD638"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uB2F4\uB2F9\uC790"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC810\uAC80 \uC77C\uC790"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uD3C9\uAC00\uC810\uC218"),
                            React.createElement("th", { scope: "col" }, "Report"),
                            React.createElement("th", { scope: "col" }, "Memo"))),
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", { className: "txt-left" }, itemDetailInfo.subZoneName),
                            React.createElement("td", { className: "txt-left" }, itemDetailInfo.roomName),
                            React.createElement("td", { className: "txt-left" }, itemDetailInfo.spgName),
                            React.createElement("td", { className: "txt-left" },
                                React.createElement("p", { className: "ellipsis" }, itemDetailInfo.itemName)),
                            React.createElement("td", { className: "txt-left" }, itemDetailInfo.serialNo),
                            React.createElement("td", { className: "txt-left" }, itemDetailInfo.responsible),
                            React.createElement("td", { className: "txt-left" }, CUTIL.utc2time("YYYY-MM-DD", itemDetailInfo.date)),
                            React.createElement("td", { className: "txt-left" },
                                React.createElement("p", { className: (itemDetailInfo.totalScore > 70)
                                        ? "score high" : (itemDetailInfo.totalScore <= 70) ? "score middle" : "" }, itemDetailInfo.totalScore)),
                            React.createElement("td", null,
                                React.createElement("button", { type: "button", className: "btn btn-file", onClick: (e) => (itemDetailInfo.reportId !== null) && onClickReportDownload(e, itemDetailInfo), disabled: (itemDetailInfo.reportId !== null) ? false : true },
                                    React.createElement("span", { className: "hide" }, "\uD30C\uC77C\uB2E4\uC6B4\uB85C\uB4DC"))),
                            React.createElement("td", null,
                                React.createElement("button", { type: "button", className: "btn btn-memo", disabled: (itemDetailInfo.memo !== null) ? false : true },
                                    React.createElement("span", { className: "hide" }, "\uBA54\uBAA8"))))))),
            React.createElement("ul", { className: "form__input inline mb-16 mt-40" },
                React.createElement("li", null,
                    React.createElement("label", { htmlFor: "company" }, "Engineer \uAC80\uC0C9"),
                    React.createElement("div", { className: "input__area ml-0" },
                        React.createElement("div", { className: "box__search" },
                            React.createElement("input", { type: "text", placeholder: "\uC9C1\uC811\uC785\uB825", value: dispName, onChange: (e) => setDispName(e.target.value), onKeyDown: (e) => handleEnterKey(e) }),
                            React.createElement("button", { type: "button", className: "btn btn-search", onClick: (e) => setEngName(dispName) },
                                React.createElement("span", { className: "hide" }, "\uC870\uD68C")))))),
            React.createElement("div", { className: "tbl-list type2" },
                React.createElement("table", { summary: "\uC0AC\uC6A9\uC790 \uD0C0\uC785, \uD68C\uC0AC, \uC774\uB984, E-mail(ID), \uC5F0\uB77D\uCC98 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C Engineer \uC815\uBCF4 \uBAA9\uB85D \uC785\uB2C8\uB2E4." },
                    React.createElement("caption", null, "Engineer \uC815\uBCF4 \uBAA9\uB85D"),
                    React.createElement("colgroup", null,
                        React.createElement("col", { style: {} })),
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC0AC\uC6A9\uC790 \uD0C0\uC785"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uD68C\uC0AC"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC774\uB984"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "E-mail(ID)"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC5F0\uB77D\uCC98"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uBC30\uC815 \uAE30\uAE30 \uC218"),
                            React.createElement("th", { scope: "col", className: "hide" }, "\uBC84\uD2BC"))),
                    React.createElement("tbody", null, (engName.length > 0)
                        ? (engineerList.filter(eng => (eng.userName.toUpperCase().includes(engName.toUpperCase()))).length <= 0)
                            ?
                                React.createElement("tr", { key: `en_tr_no` },
                                    React.createElement("td", { colSpan: 7 },
                                        React.createElement("p", { className: "nodata-intable" }, "\uAC80\uC0C9\uB41C Engineer\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.")))
                            : engineerList.filter(eng => (eng.userName.toUpperCase().includes(engName.toUpperCase()))).map((eng, idx) => (React.createElement("tr", { key: `en_tr_${idx.toString()}` },
                                React.createElement("td", { className: "txt-left fontMedium" }, (eng.role == "ENGINEER") ? "Engineer" : ""),
                                React.createElement("td", { className: "txt-left" }, eng.companyName),
                                React.createElement("td", { className: "txt-left" }, eng.userName),
                                React.createElement("td", { className: "txt-left" }, eng.email),
                                React.createElement("td", { className: "txt-left" }, eng.phoneNumber),
                                React.createElement("td", { className: "txt-left" }, eng.itemCnt),
                                React.createElement("td", null,
                                    (checkChange != eng.userIdPk) &&
                                        React.createElement("button", { type: "button", className: "btn-basic", onClick: (e) => engineerSelect(e, eng) },
                                            React.createElement("span", null, "\uC120\uD0DD")),
                                    (checkChange == eng.userIdPk) &&
                                        React.createElement("button", { type: "button", className: "btn-basic bg-navy", onClick: (e) => engineerSelect(e, eng) },
                                            React.createElement("span", null, "\uBC30\uC815"))))))
                        : engineerList.map((eng, idx) => (React.createElement("tr", { key: `en_tr_${idx.toString()}` },
                            React.createElement("td", { className: "txt-left fontMedium" }, (eng.role == "ENGINEER") ? "Engineer" : ""),
                            React.createElement("td", { className: "txt-left" }, eng.companyName),
                            React.createElement("td", { className: "txt-left" }, eng.userName),
                            React.createElement("td", { className: "txt-left" }, eng.email),
                            React.createElement("td", { className: "txt-left" }, eng.phoneNumber),
                            React.createElement("td", { className: "txt-left" }, eng.itemCnt),
                            React.createElement("td", null,
                                (checkChange != eng.userIdPk) &&
                                    React.createElement("button", { type: "button", className: (checkChange != eng.userIdPk) ? "btn-basic" : "btn-basic bg-navy", onClick: (e) => engineerSelect(e, eng) },
                                        React.createElement("span", null, "\uC120\uD0DD")),
                                (checkChange == eng.userIdPk) &&
                                    React.createElement("button", { type: "button", className: "btn-basic bg-navy", onClick: (e) => engineerSelect(e, eng) },
                                        React.createElement("span", null, "\uBC30\uC815")))))))))),
        React.createElement("div", { className: "popup__footer" }, (!checkChange) ?
            React.createElement("button", { type: "button", disabled: true },
                React.createElement("span", null, "\uD655\uC778"))
            : (itemInfo.oldDeviceConsult == 0) ?
                React.createElement("button", { type: "button", onClick: (e) => engineerDone(itemInfo.itemId, checkChange, itemDetailInfo.requestUserIdPk) },
                    React.createElement("span", null, "\uD655\uC778"))
                :
                    React.createElement("button", { type: "button", onClick: (e) => changeDone(itemInfo.itemId, checkChange, itemDetailInfo.oldDeviceReqUserIdPk) },
                        React.createElement("span", null, "\uD655\uC778")))));
}
